export default __webpack_public_path__ + "static/media/contextualMenu.cae4f189.svg";